import * as types from "./actionTypes";
import * as engineerApi from "../../api/engineerApi";
import * as ordersApi from "../../api/orderApi";

// Private documents and photos come back from Strapi as signed links that expire, so the profile
// and the job being completed are reloaded to get fresh links. A refresh runs at most once a
// minute: a file that's genuinely missing would otherwise fail and refresh in a loop.
const MIN_INTERVAL_MS = 60 * 1000;

let inFlight = null;
let lastRefreshAt = 0;

export function resetSignedMediaRefresh() {
  inFlight = null;
  lastRefreshAt = 0;
}

function ensureFreshToken(auth) {
  if (auth.isAuthenticated()) return Promise.resolve(true);
  return new Promise((resolve) => auth.renewToken((err) => resolve(!err)));
}

export function refreshSignedMedia(auth) {
  return function (dispatch, getState) {
    if (inFlight) return inFlight;
    if (Date.now() - lastRefreshAt < MIN_INTERVAL_MS) return Promise.resolve();
    lastRefreshAt = Date.now();

    inFlight = ensureFreshToken(auth)
      .then((tokenOk) => {
        if (!tokenOk) return;
        const { profile, completingJob } = getState();
        const reloads = [];

        if (profile && Object.keys(profile).length > 0) {
          reloads.push(
            engineerApi.getEngineerById(auth).then((refreshed) => dispatch({ type: types.REFRESH_ENGINEER, profile: refreshed }))
          );
        }
        if (completingJob && completingJob.orderNumber) {
          reloads.push(
            ordersApi
              .getOrderWithCompletionDetails(auth, completingJob.orderNumber)
              .then((refreshed) => dispatch({ type: types.REFRESH_COMPLETING_JOB, completingJob: refreshed }))
          );
        }
        return Promise.allSettled(reloads);
      })
      .finally(() => {
        inFlight = null;
      });

    return inFlight;
  };
}
